import { useState } from 'react';
import { SimpleForm, TextInput, ReferenceArrayInput, SelectArrayInput, required, useRecordContext, Labeled } from 'react-admin';
import { isValidVideoUrl, getEmbedUrlAndDimensions } from '../../lib/media/videoFunctions';
import { DateTimePicker } from '../../components/Input/DateTimePickerInput';

const isSHortYoutubeUrl = (url: string) => {
  return url.toLowerCase().includes('/shorts/') ? undefined : 'Ongeldige video URL. Alleen YouTube Shorts URLs zijn toegestaan.';
}

const rules = {
  url: [required(), isValidVideoUrl],
};

interface VideoPreviewProps {
  url: string;
  width: number;
  height: number;
}

export const VideoForm = (props: any) => {
  const record = useRecordContext();
  const [preview, setPreview] = useState<VideoPreviewProps>(record ? { url: record.videoEmbedUrl, width: record.videoWidth, height: record.videoHeight } : null);

  const showVideo = (event: any) => {
    const url = event.target.value;
    if (isValidVideoUrl(url) === undefined) {
      const embedData = getEmbedUrlAndDimensions({ url, nocookie: false, controls: false, modestBranding: true, loop: true });
      setPreview(embedData);
    }
  }
  return (
    <SimpleForm {...props}>
      <TextInput source="title" required />
      <ReferenceArrayInput label="LTO" source="ltoIds" reference="ltos">
        <SelectArrayInput optionText="name" required />
      </ReferenceArrayInput>
      <TextInput source="videoUrl" validate={rules.url} onBlur={showVideo} />
      {preview && (
        <>
          <Labeled
            label={"resources.videos.fields.preview"}
          >
            <></>
          </Labeled>

          <div>
            <iframe title='preview' width={preview.width * 1.5} height={preview.height * 1.5} src={preview.url}></iframe>
          </div>
        </>
      )}
      <DateTimePicker source="publishedAt" convertFromUTC validate={null} label="resources.news.fields.publishAt" />
    </SimpleForm>
  )
}
